import { forwardRef, type ReactNode } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { type Nbc } from '@vakantiesnl/types';

import { useCustomStyles } from './AccommodationDescription.style';

type Props = {
	title?: ReactNode | string;
	description: string;
	descriptionTitle?: string;
	paragraphs?: Nbc.ParagraphSection[];
};

export const AccommodationDescription = forwardRef<HTMLDivElement, Props>(
	({ title, description, descriptionTitle = '', paragraphs }, ref) => {
		const { classes } = useCustomStyles();

		const { isMobile } = useBreakpoints();

		if (!paragraphs && !description) return null;
		return (
			<div ref={ref}>
				{title &&
					(typeof title === 'string' ? (
						<Typography variant="headingMd" as="h4" className={classes.descriptionTypography}>
							{title}
						</Typography>
					) : (
						title
					))}
				{descriptionTitle && (
					<Typography
						variant={isMobile ? 'headingSm' : 'headingMd'}
						as="h4"
						className={classes.descriptionTypography}
					>
						{descriptionTitle}
					</Typography>
				)}
				{description && (
					<Typography variant="bodyMd" as="p" className={classes.descriptionTypography}>
						{description}
					</Typography>
				)}

				{paragraphs && (
					<>
						{paragraphs.map((paragraph, key) => (
							<div key={key} className={classes.paragraphsContainer}>
								<Typography
									variant={isMobile ? 'headingSm' : 'headingMd'}
									className={classes.descriptionTypography}
									as="h4"
								>
									{paragraph.title}
								</Typography>
								<Typography variant="bodyMd" as="p" className={classes.descriptionTypography}>
									{paragraph.text}
								</Typography>
							</div>
						))}
					</>
				)}
			</div>
		);
	},
);
AccommodationDescription.displayName = 'AccommodationDescription';
